<template>
  <div id="lerner-header" class="flex relative" :class="{'header-shadow': showShadow}">
    <loading-indicator v-if="pending"></loading-indicator>
    <div class="col-lg-4 col-md-5">
      <div class="mt-4">
        <router-link to="/">
          <img class="logo" alt="logo" src="../assets/images/lerner-makerlab-logo.svg"/>
        </router-link>
      </div>
    </div>
    <div class="col-lg-8 col-md-7 px-0" v-if="showLoginForm || showLogout">
      <div class="logout pr-3" v-if="showLogout">
        <a class="text-grey-2 text-xs" href="#" v-on:click.prevent="logout">Log Out</a>
      </div>
      <div v-if="showLoginForm" id="header-login" class="md:px-0 md:px-3 py-4 h-full">
        <login-form v-on:submit="submit"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { LOGIN } from '@/store/actions/auth.actions';
  import { LOGOUT } from '@/store/actions/auth.actions';
  import LoadingIndicator from '@/component/LoadingIndicator';
  import LoginForm from '@/component/LoginForm';

  export default {
    name: 'LernerHeader',

    components: {
      LoginForm,
      LoadingIndicator
    },

    props: {
      pending: {
        default: false,
        type: Boolean
      },
      showLoginForm: {
        default: true,
        type: Boolean
      },
      showLogout: {
        default: false,
        type: Boolean
      },
      showShadow: {
        default: true,
        type: Boolean
      }
    },

    methods: {
      logout() {
        this.$store.dispatch(LOGOUT)
            .then(() => this.$router.push({ name: 'home' }))
      },

      submit({email, password}) {
        this.$store
          .dispatch(LOGIN, {email, password})
          .then(() => this.$router.push({name: 'admin'}))
          .catch(response => {
            if (response.status === 403) {
              this.$router.push({name: 'invalid-subscription'});
            }
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .logo {
    width: 305px;
    height: 46px;
  }

  #lerner-header {
    min-height: config('staticHeight.unAuthHeader');

    &.header-shadow:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 16px;
      left: 0;
      bottom: -16px;
      background: linear-gradient(to bottom, rgba(0,0,0,0.1) 0%,rgba(0,0,0,0) 100%);
    }

    .logout {
      @apply flex items-center justify-end h-full;
    }
  }

  #header-login {
    color: config('colors.white');
    background-color: #c0c0c0;
  }
</style>
